import axios from "./axios.callcenter";
import { TWaitingRoomEntry } from "@/hooks/call-center/useWaitingRoom";

export const getWaitingRoomQueue = async (): Promise<TWaitingRoomEntry[]> => {
  const response = await axios.get("/personal-room/waiting-room");
  return response.data;
};
